import { createComponent } from '@carvana/vdp-components';
import styled from 'styled-components';
import SelectionIndicator from '@/vdp/SelectionIndicator';
import { stickyBannerHeightDesktop } from '@/vdp/StickyBanner/BannerStyles';
import { desktopNavHeight } from './constants';
import SmoothAnchor from './SmoothAnchor';

export const DesktopPageNavigationWrapper = styled.div.attrs({
  className: 'relative'
})`
  & > span:first-of-type {
    position: absolute;
    top: 0;
  }
`;

export const DesktopStickyPageNavigationWrapper = styled.div.attrs({
  className: 'w-full'
})`
  position: sticky;
  top: ${stickyBannerHeightDesktop}px;
  left: 0;
  right: 0;
  z-index: 100;
`;

export const DesktopStickyPageNavigationInnerWrapper = styled.div.attrs({
  className: 'grid'
})<{ isSticky?: boolean }>`
  grid-template: 1fr / 145px 1fr 145px;
  max-width: 1800px;
  margin: 0 auto;
  height: ${desktopNavHeight}px;
  background: var(--cvna-color-white);
  padding: 0 32px;

  &.box-shadow {
    box-shadow: 0 3px 21px rgba(0, 0, 0, 0.14);
  }
`;

const NavigationColumn = createComponent('div', {
  className: 'flex items-center'
});

export const NavigationColumnOne = createComponent(NavigationColumn, {
  className: 'justify-start'
});

export const NavigationColumnTwo = createComponent(NavigationColumn, {
  className: 'flex-1 justify-center'
});

export const NavigationButton = styled.a.attrs({
  className: 'bg-transparent flex items-center justify-center'
})`
  flex-wrap: nowrap;

  &:hover {
    background: transparent;
  }
`;

export const NavigationTab = createComponent(SmoothAnchor, {
  className: 'flex h-full items-center justify-center mx-16 relative',
  'data-qa': 'navigation-tab'
});

export const NavigationTabIndicator = createComponent(SelectionIndicator, {
  className: 'w-full'
});

export const NavigationText = createComponent('p', {
  className: 't-header-xs text-blue-6 uppercase',
  'data-qa': 'navigation-text'
});
